import { Button, ButtonVariants, useAuth, Users, UserUpdate } from "@app/shared";
import { FC, useEffect } from "react";
import { DashboardLayout } from "../../layouts";
import { Input, PageContainer } from "../../shared";
import { useNavigate } from "react-router-dom";
import { Pages } from "..";
import { useModel } from "../../../hooks";
import { toastError, toastSuccess } from "../../../helpers";

export const EditProfile: FC = () => {
    const auth = useAuth();
    const [editProfile, helpers] = useModel(UserUpdate);
    const navigate = useNavigate();

    const handleNavigateBack = () => {
        navigate(Pages.AccountDetails.getUrl());
    };

    const HandleUpdateProfile = async () => {
        try {
            await Users.updateUser(editProfile as UserUpdate);
            await auth.reload();
            toastSuccess("Success", "Your profile has been updated!");
            setTimeout(() => {
                navigate(Pages.AccountDetails.getUrl());
            }, 1000);
        } catch (ex) {
            toastError("Error", (ex as object).toString());
        }
    };

    useEffect(() => {
        editProfile.firstName = auth.user?.firstName;
        editProfile.lastName = auth.user?.lastName;
    }, []);

    return (
        <DashboardLayout centerChildren="Account Details">
            <PageContainer title="Edit Profile">
                <Input label="First Name" {...helpers.bindingsFor("firstName")} />
                <Input label="Last Name" {...helpers.bindingsFor("lastName")} />
                <div className="flex pt-5 gap-5 place-items-center justify-center">
                    <Button variant={ButtonVariants.Secondary} onClick={handleNavigateBack}>
                        Back
                    </Button>
                    <Button onClick={HandleUpdateProfile}>Change</Button>
                </div>
            </PageContainer>
        </DashboardLayout>
    );
};
